// extracted by mini-css-extract-plugin
export default {"input":"EditWeeklyForm_input__WKrSt","del":"EditWeeklyForm_del__aeyjE"};